import './Game.scss';

function Attributes(props: { att: number, def: number, pierce: number }) {
    return (
        <div className='attribute-stats'>
            <span className='attr-title'>Att: {props.att}</span>
            <span className='attr-title'>Def: {props.def}</span>
            <span className='attr-title'>Prc: {props.pierce}</span>
        </div>
    );
}

export default Attributes;